export const embedcodetypeConstants = {
    GETALL_REQUEST: 'EMBEDCODETYPE_GETALL_REQUEST',
    GETALL_SUCCESS: 'EMBEDCODETYPE_GETALL_SUCCESS',
    GETALL_FAILURE: 'EMBEDCODETYPE_GETALL_FAILURE',

    DELETE_REQUEST: 'EMBEDCODETYPE_DELETE_REQUEST',
    DELETE_SUCCESS: 'EMBEDCODETYPE_DELETE_SUCCESS',
    DELETE_FAILURE: 'EMBEDCODETYPE_DELETE_FAILURE'
};
